export default __webpack_public_path__ + "static/media/affiliate-commission-banner-cn.ddf51935.webp";